import { ComponentPropsWithoutRef, FC, HTMLProps, MouseEvent } from 'react';
import { Button } from 'react-daisyui';

type LoadingButtonProps = {
  loading?: boolean;
} & ComponentPropsWithoutRef<typeof Button> & { type?: HTMLProps<HTMLButtonElement>['type'] };

const LoadingButton: FC<LoadingButtonProps> = ({ loading = false, onClick, children, disabled, ...rest }) => {
  const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
  };

  if (loading) {
    return (
      <Button loading={loading} disabled={true} {...rest}>
        {children}
      </Button>
    );
  } else {
    return (
      <Button onClick={handleOnClick} disabled={disabled} {...rest}>
        {children}
      </Button>
    );
  }
};

export default LoadingButton;
